var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2787 2.67868C13.4503 1.50711 15.3497 1.50711 16.5213 2.67868C17.6929 3.85025 17.6929 5.74975 16.5213 6.92132L15.0521 8.39052C14.7006 8.74199 14.7006 9.31184 15.0521 9.66331C15.4036 10.0148 15.9734 10.0148 16.3249 9.66331L17.7941 8.19411C19.6686 6.3196 19.6686 3.2804 17.7941 1.40589C15.9196 -0.468629 12.8804 -0.468629 11.0059 1.40589L7.40589 5.00589C5.53137 6.8804 5.53137 9.91959 7.40589 11.7941C7.49339 11.8816 7.58356 11.9651 7.67616 12.0446C8.05328 12.3684 8.62149 12.3252 8.94529 11.9481C9.26909 11.571 9.22586 11.0028 8.84874 10.679C8.79067 10.6291 8.73393 10.5766 8.67868 10.5213C7.50711 9.34975 7.50711 7.45025 8.67868 6.27868L12.2787 2.67868Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5238 7.15534C11.1467 6.83154 10.5785 6.87476 10.2547 7.25188C9.93091 7.629 9.97413 8.19721 10.3513 8.52101C10.4093 8.57087 10.4661 8.62341 10.5213 8.67867C11.6929 9.85024 11.6929 11.7497 10.5213 12.9213L6.92132 16.5213C5.74975 17.6929 3.85025 17.6929 2.67868 16.5213C1.50711 15.3497 1.50711 13.4502 2.67868 12.2787L4.14788 10.8095C4.49935 10.458 4.49935 9.88814 4.14788 9.53667C3.79641 9.1852 3.22656 9.1852 2.87509 9.53667L1.40589 11.0059C-0.468629 12.8804 -0.468629 15.9196 1.40589 17.7941C3.2804 19.6686 6.3196 19.6686 8.19411 17.7941L11.7941 14.1941C13.6686 12.3196 13.6686 9.28039 11.7941 7.40587C11.7066 7.31837 11.6164 7.23485 11.5238 7.15534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.fbba2a25286290239bb44722e159baa7.svg";
export { ForwardRef as ReactComponent };